import PropTypes from 'prop-types';

export default {
  jan: PropTypes.number,
  feb: PropTypes.number,
  mar: PropTypes.number,
  apr: PropTypes.number,
  may: PropTypes.number,
  jun: PropTypes.number,
  jul: PropTypes.number,
  aug: PropTypes.number,
  sep: PropTypes.number,
  oct: PropTypes.number,
  nov: PropTypes.number,
  dec: PropTypes.number
};
